import { IChemicalExposureLogPerson } from '../models/chemical-exposure.model';

export function chemicalExposurePersonId(person: IChemicalExposureLogPerson): string {
  return person.userId || person.employmentId || '';
}
